export default class Globals {
    public static readonly MaxPersonsPerSlot: number = 30;
    public static readonly Phone: string = "06 03 46 59 81";
    public static readonly Email: string = "lafermerainbow@gmail.com";

    public static readonly TarifIndividuelNLG: number = 4;
    public static readonly TarifIndividuelHNLG: number = 5;
    public static readonly TarifFamilleNLG: number = 15;
    public static readonly TarifFamilleHNLG: number = 19;
    public static readonly TarifAnniversaire: number = 56;
    
    public static readonly Tarifs = [
        {
            type: "Entrée individuelle",
            prixNoisy: `${Globals.TarifIndividuelNLG} €`,
            prixHorsNoisy: `${Globals.TarifIndividuelHNLG} €`
        },
        {
            type: "Famille de 5 personnes",
            prixNoisy: `${Globals.TarifFamilleNLG} €`,
            prixHorsNoisy: `${Globals.TarifFamilleHNLG} €`
        },
        {
            type: "Adhésion annuelle individuelle",
            prixNoisy: '40 €',
            prixHorsNoisy: '45 €'
        },
        {
            type: "Adhésion annuelle famille (5 personnes)",
            prixNoisy: '90 €',
            prixHorsNoisy: '110 €'
        },
        {
            type: "Groupe (10 personnes) *",
            prixNoisy: '30 €',
            prixHorsNoisy: '40 €'
        },
        {
            type: "Groupe (30 personnes dont 3 animateurs) *",
            prixNoisy: '80 €',
            prixHorsNoisy: '120 €'
        },
        {
            type: "Prestation Anniversaire (par invité) **",
            prixNoisy: '8 €',
            prixHorsNoisy: '8 €'
        }
    ];
    public static readonly TarifsSnack = [
        {
            type: "Crêpe sucrée",
            prix: "3 €"
        },
        {
            type: "Crêpe chocolat ou confiture",
            prix: "4 €"
        },
        {
            type: "Crêpe complète",
            prix: "6,50 €"
        }
    ];
    public static getQueryStringParams = (query:string) => {
        if (query.indexOf("?") >= 0) query = query.substr(query.indexOf("?") + 1);
        return query
            ? (/^[?#]/.test(query) ? query.slice(1) : query)
                .split('&')
                .reduce((params: any, param) => {
                        let [key, value] = param.split('=');
                        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                        return params;
                    }, {}
                )
            : {}
    };
}
